module.exports = __webpack_public_path__ + "static/media/14_after.a6ca83aa.jpg";